import { MenuItem } from "./menu-item.interface"

// had to change this to a class so i could call super(new sideMenu()) in sideMenuStore
export class SideMenu {
    visible!             : boolean
    showSideMenuText!    : boolean
    topSideMenuItems!    : MenuItem[]
    bottomSideMenuItems! : MenuItem[]
}